export const frEditor = {
    'editor.button.cancel.label': 'Annuler',
    'editor.button.add.label': 'Ajouter',

    'editor.link.input.target.label': 'Cible du lien',
    'editor.link.input.target.placeholder': 'Saisissez la cible du lien',
    'editor.link.input.title.label': 'Titre du lien',
    'editor.link.input.title.placeholder': 'Saisissez le titre du lien',

    'editor.image.dropzone.title': 'Ajouter une photo',
    'editor.image.dropzone.label': 'Visuel photo',
    'editor.image.dropzone.cancel.button.label': 'Annuler',
};
